<mat-dialog-actions class="dialog-close">
    <img src="assets/images/dialog-close.svg" alt="close" mat-dialog-close class="dialog-close-img"
        (click)="dialogClose()" (keydown.enter)="dialogClose()" (keydown.space)="dialogClose()">

</mat-dialog-actions>

<div class="dialog-content caivano-select-popup">
    <div class="dialog-title">
        <span>
            {{'machine_view.select_line' | translate}}
        </span>
    </div>
</div>

<div class="dialog-content caivano-select-popup">
    <div class="dialog-form">
        <form (ngSubmit)="onSubmit()" [formGroup]="lineSelector">
            <div class="common-form-field selector-wrapper">
                <mat-form-field appearance="outline" class="fw selector-form-field">
                    <mat-label>{{'report.table_header_cluster' | translate}}</mat-label>
                    <input type="text" matInput formControlName="cluster" [matAutocomplete]="auto"
                        (change)="valueReset('cluster')" (ngModelChange)="autoCompleteCluster($event)">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let option of uniqueLineCluster" [value]="option?.subRegionName"
                            (click)="onClusterChange(option)" (keydown.enter)="onClusterChange(option)">
                            {{option.subRegionName}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint class="error" align="end" *ngIf="lineSelector?.controls?.clusterid.hasError('required')">
                        {{'report.please_select_from_list' | translate}}!
                    </mat-hint>
                </mat-form-field>
            </div>
            <div class="selector-wrapper common-form-field">
                <mat-form-field appearance="outline" class="selector-form-field fw">
                    <mat-label>
                        {{'report.table_header_factory' | translate}}
                    </mat-label>
                    <input type="text" matInput formControlName="factory" (change)="valueReset('factory')"
                        [matAutocomplete]="autofact" (ngModelChange)="autoCompleteFactory($event)">
                    <mat-autocomplete #autofact="matAutocomplete">
                        <mat-option *ngFor="let option of selectedClusterFactory"
                            (keydown.enter)="onFactoryChange(option)" (keydown.space)="onFactoryChange(option)"
                            (click)="onFactoryChange(option)" [value]="option?.name">
                            {{option.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint align="end" class="error" *ngIf="lineSelector?.controls?.factoryid.hasError('required') &&
                        lineSelector?.controls?.factory.status=='VALID'">
                        {{'report.please_select_from_list' | translate}}!</mat-hint>
                </mat-form-field>
            </div>
            <div class="selector-wrapper common-form-field">
                <mat-form-field appearance="outline" class="selector-form-field fw">
                    <mat-label>
                        {{'report.table_header_line' | translate}}
                    </mat-label>
                    <input type="text" matInput [matAutocomplete]="autoline" formControlName="line"
                        (change)="valueReset('line')">
                    <mat-autocomplete #autoline="matAutocomplete">
                        <mat-option *ngFor="let option of linefilteredOptions | async"
                            (keydown.enter)="onLineChange(option)" (keydown.space)="onLineChange(option)"
                            (click)="onLineChange(option)" [value]="option?.name">
                            {{option.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint align="end" class="error" *ngIf="lineSelector?.controls?.lineid.hasError('required') &&
                        lineSelector?.controls?.line.status=='VALID'">
                        {{'report.please_select_from_list' | translate}}!</mat-hint>
                </mat-form-field>
            </div>
            <div class="selector-wrapper common-form-field" *ngIf="selectedLR==='LR-dashboard'">
                <mat-form-field appearance="outline" class="selector-form-field fw">
                    <mat-label>
                        Order Number
                    </mat-label>
                    <mat-select formControlName="orderLR">
                        <mat-option *ngFor="let option of orderNumberOptions" (keydown.enter)="onOrderChange(option)"
                            (keydown.space)="onOrderChange(option)" (click)="onOrderChange(option)" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="common-form-field" *ngIf="selectedLR==='LR-dashboard'">
                <div class="newClass">
                    <mat-form-field class="example-full-width" style="width: 340px;" appearance="fill" required>
                        <mat-label>Choose a date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="dateSelectionLR" [min]="minDate"
                            [max]="maxDate" required (dateChange)="valueChanged($event)">
                        <mat-datepicker-toggle matSuffix [for]="picker">
                            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>



            </div>
            <div class="selector-wrapper common-form-field" *ngIf="selectedLR==='LR-dashboard'">
                <mat-form-field appearance="outline" class="selector-form-field fw" required>
                    <mat-label>
                        Time
                    </mat-label>
                    <mat-select formControlName="timeSelectionLR" [disabled]="!enableTime" required>
                        <mat-option *ngFor="let option of timefilteredOptions" (keydown.enter)="onTimeChange(option)"
                            (keydown.space)="onTimeChange(option)" (click)="onTimeChange(option)" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-select>
                    <mat-hint align="end" class="error" *ngIf="lineSelector?.controls?.timeSelectionLR.hasError('required') &&
                lineSelector?.controls?.timeSelectionLR.status=='VALID' && selectedLR==='LR-dashboard'">
                        {{'report.please_select_from_list' | translate}}!</mat-hint>
                </mat-form-field>
            </div>
            <div class="text-align-center">
                <button mat-raised-button color="primary" [ngClass]="{'submit-btn' : lineSelector.valid}"
                    [disabled]="!lineSelector.valid" type="submit">
                    {{'common.submit' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>